/**
 * Keep in sync with backend: Api::External::Version
 */
export enum ApiVersion {
  /* It's worth allowing PascalCase */
  /* eslint-disable @typescript-eslint/naming-convention */
  V_2018_08_16 = '2018-08-16',
  V_2019_10_17 = '2019-10-17',
  V_2019_11_30 = '2019-11-30',
  V_2020_01_13 = '2020-01-13',
  V_2020_05_18 = '2020-05-18',
  V_2021_02_21 = '2021-02-21',
  V_2021_05_14 = '2021-05-14',
  V_2021_07_05 = '2021-07-05',
  V_2021_08_18 = '2021-08-18',
  V_2022_09_01 = '2022-09-01',
  V_2023_01_05 = '2023-01-05',
  /* eslint-enable @typescript-eslint/naming-convention */
}

export const LATEST_API_VERSION = ApiVersion.V_2023_01_05;

/**
 * Keep in sync with backend: Api::KeyInflection
 */
export enum ApiKeyInflection {
  Camel = 'camel',
  Kebab = 'kebab',
  Snake = 'snake',
}

export const API_KEY_INFLECTION_LABEL_MAP: Record<ApiKeyInflection, string> = {
  [ApiKeyInflection.Kebab]: 'Kebab',
  [ApiKeyInflection.Camel]: 'Camel',
  [ApiKeyInflection.Snake]: 'Snake',
};

export const DEFAULT_API_KEY_INFLECTION = ApiKeyInflection.Kebab;
